import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const routes = [
    {
        path: '*',
        redirect: '/login'
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('../page/login.vue'),
    },
    {
        name: 'home',
        path: '/home',
        component: () => import('../components/home.vue'),
        // meta: {
        //     title: '打印订单详情',
        //     keepAlive: false
        //   }
    }, {
        name: 'PrintContract',
        path: '/PrintContract',
        component: () => import('../page/contract/subContract/printContract.vue'),
       
    },{
        name: 'accountsReceiveTotal',
        path: '/accountsReceiveTotal',
        component: () => import('../page/dataCenter/accountsReceiveTotal'),

    }, {
        name: 'payTotal',
        path: '/payTotal',
        component: () => import('../page/dataCenter/payTotal'),

    },{
        name: 'accountsReceiveTotalA',
        path: '/accountsReceiveTotalA',
        component: () => import('../page/dataCenterA/accountsReceiveTotal'),

    }, {
        name: 'payTotalA',
        path: '/payTotalA',
        component: () => import('../page/dataCenterA/payTotal'),

    }, {
        name: 'accountsReceiveDataSource',
        path: '/accountsReceiveDataSource',
        component: () => import('../page/dataCenter/accountsReceiveDataSource'),
    } ,{
        name: 'payDataSource',
        path: '/payDataSource',
        component: () => import('../page/dataCenter/payDataSource'),
    },{
        name: 'overviewFile',
        path: '/overviewFile',
        component: () => import('../page/contract/commonCell/overviewFile'),
    },{
        name: 'costTotal',
        path: '/costTotal',
        component: () => import('../page/dataCenterA/profit/costTotal'),

    }

]
// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
const router = new Router({routes});

// router.beforeEach((to, from, next) => {
//     if ((to.name == 'login' || to.name == 'ownerDown' || to.name == 'propertyDown') && sessionStorage.getItem('userCode')) {
//         next('/home');
//         return;
//     }
//     //登录暂时无法使用
//     if (to.name == 'home' && !sessionStorage.getItem('userCode')) {
//         next('/login');
//         return;
//     }
//     next();
// });
export {
    router
};
